'use strict';
var novicell = novicell || {};

novicell.backButton = novicell.backButton || function () {

    function init() {
        backButon();
    }

    function backButon() {
        let prevUrl = document.referrer;

        if ( !prevUrl.includes('app') || prevUrl.includes('onboarding') ) {
            var element = document.getElementById('back-button');

            if ( element ) {
                element.style.display = 'none';
            }
        }
    }

    return {
        init : init,
        backButon : backButon
    };

}();